import React from "react";
import { FileText, Download, Save, Undo, Redo, RotateCcw } from "lucide-react";

export function ResultsSkeleton() {
  return (
    <div className="flex flex-col h-full bg-slate-50 opacity-50 pointer-events-none animate-pulse">
      {/* Tabs Header Skeleton */}
      <div className="flex items-center gap-4 mb-2 border-b border-slate-200 mt-4 px-4 pointer-events-none">
        <div className="pb-3 px-1 text-sm font-medium border-b-2 border-slate-300 text-slate-300">
           Optimized Resume
        </div>
        <div className="pb-3 px-1 text-sm font-medium text-slate-300">
           Cover Letter
        </div>
      </div>

      <div className="flex-1 bg-white border border-slate-200 rounded-lg shadow-sm overflow-hidden flex flex-col mx-4 mb-4">
          {/* Toolbar Skeleton */}
          <div className="flex items-center justify-between p-4 border-b border-slate-100 bg-slate-50/50">
             <div className="flex items-center gap-2">
                <FileText className="h-4 w-4 text-slate-300" />
                <div className="h-4 w-32 bg-slate-200 rounded"></div>
             </div>
             <div className="flex items-center gap-2 text-slate-300">
                 <div className="flex items-center gap-1 mr-2 border-r pr-2">
                     <div className="h-8 w-8 bg-slate-200 rounded"></div>
                     <div className="h-8 w-8 bg-slate-200 rounded"></div>
                     <div className="h-8 w-8 bg-slate-200 rounded ml-1"></div>
                 </div>
                 <div className="flex items-center gap-2">
                     <div className="h-8 w-32 bg-slate-200 rounded"></div>
                     <div className="h-8 w-32 bg-slate-200 rounded"></div>
                 </div>
             </div>
          </div>

          {/* Content Skeleton */}
          <div className="flex-1 overflow-hidden p-8 bg-white">
              <div className="max-w-3xl mx-auto space-y-8">
                  {/* Header Info */}
                  <div className="text-center space-y-4 flex flex-col items-center">
                      <div className="h-8 w-1/2 bg-slate-200 rounded"></div>
                      <div className="h-4 w-2/3 bg-slate-100 rounded"></div>
                  </div>

                  {/* Summary Section */}
                  <div className="space-y-3">
                      <div className="h-4 w-32 bg-slate-200 rounded uppercase"></div>
                      <div className="space-y-2">
                          <div className="h-3 w-full bg-slate-100 rounded"></div>
                          <div className="h-3 w-full bg-slate-100 rounded"></div>
                          <div className="h-3 w-3/4 bg-slate-100 rounded"></div>
                      </div>
                  </div>

                  {/* Skills Section */}
                  <div className="space-y-3">
                      <div className="h-4 w-16 bg-slate-200 rounded uppercase"></div>
                      <div className="h-16 w-full bg-slate-100 rounded"></div>
                  </div>

                  {/* Experience Section */}
                  <div className="space-y-6">
                      <div className="h-4 w-32 bg-slate-200 rounded uppercase"></div>
                      
                      {/* Experience Item 1 */}
                      <div className="space-y-2">
                          <div className="flex justify-between">
                              <div className="h-5 w-1/3 bg-slate-200 rounded"></div>
                              <div className="h-4 w-24 bg-slate-100 rounded"></div>
                          </div>
                          <div className="h-4 w-1/4 bg-slate-100 rounded"></div>
                          <div className="pl-4 space-y-2 mt-2">
                              <div className="h-3 w-full bg-slate-100 rounded"></div>
                              <div className="h-3 w-11/12 bg-slate-100 rounded"></div>
                              <div className="h-3 w-10/12 bg-slate-100 rounded"></div>
                          </div>
                      </div>

                      {/* Experience Item 2 */}
                      <div className="space-y-2">
                          <div className="flex justify-between">
                              <div className="h-5 w-1/3 bg-slate-200 rounded"></div>
                              <div className="h-4 w-24 bg-slate-100 rounded"></div>
                          </div>
                          <div className="h-4 w-1/4 bg-slate-100 rounded"></div>
                          <div className="pl-4 space-y-2 mt-2">
                              <div className="h-3 w-full bg-slate-100 rounded"></div>
                              <div className="h-3 w-11/12 bg-slate-100 rounded"></div>
                          </div>
                      </div>
                  </div>

                   {/* Education Section */}
                   <div className="space-y-4">
                      <div className="h-4 w-24 bg-slate-200 rounded uppercase"></div>
                       <div className="space-y-2">
                          <div className="flex justify-between">
                              <div className="h-5 w-1/3 bg-slate-200 rounded"></div>
                              <div className="h-4 w-16 bg-slate-100 rounded"></div>
                          </div>
                          <div className="h-4 w-1/2 bg-slate-100 rounded"></div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
  );
}
